import { Stack, Typography } from '@mui/material';
import { FunctionComponent, ReactElement, ReactNode } from 'react';

interface SiteFormSectionProps {
	title: string;
	description: string;
	children: ReactNode;
	width?: string | null;
}

const SiteFormSection: FunctionComponent<SiteFormSectionProps> = ({
	title,
	description,
	children,
	width,
}): ReactElement => (
	<Stack direction="column" spacing={2.5}>
		<Stack direction="column" spacing={0.5}>
			<Typography variant="h6">{title}</Typography>
			<Typography variant="body1" color="text.secondary">
				{description}
			</Typography>
		</Stack>
		<Stack sx={{ width }} direction="column" spacing={2}>
			{children}
		</Stack>
	</Stack>
);

export default SiteFormSection;
